import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OPEN_GRAPH_SERVICE } from 'projects/suche-lib/src/lib/services/open-graph.service';
import { OpenGraphService } from '../../service/open-graph.service';

@Component({
  selector: 'now-wbsuche-app-angebot-nicht-gefunden',
  imports: [RouterLink],
  templateUrl: './angebot-nicht-gefunden.component.html',
  styleUrl: './angebot-nicht-gefunden.component.scss'
})
export class AngebotNichtGefundenComponent {
  constructor() {
    const openGraphService = inject<OpenGraphService>(OPEN_GRAPH_SERVICE, { optional: true });

    openGraphService?.setDescription(
      'Weiterbildungen suchen und finden - bereitgestellt von einer der größten Weiterbildungsdatenbanken Deutschlands.'
    );
  }
}
